import styled from '@emotion/styled';
import { Card } from '@shared/ui/index';

export const SCard = styled(Card)`
    padding: 10px;
`;